import { useEffect, useState } from 'react'
import { Box, useMediaQuery } from '@mui/material'

// Background slides of the Home page, in order. Any image works (JPG/PNG/SVG).
export const HOME_BACKGROUNDS = [
  '/assets/background.jpg',
  '/assets/backgrounds/radar-scope.svg',
  '/assets/backgrounds/airfield-night.svg',
  '/assets/backgrounds/flight-network.svg',
]

const SLIDE_MS = 9000    // each background stays this long
const FADE_MS = 1600     // crossfade

// Same darkening as the single background (TopLeft) so the text stays readable on every slide
const OVERLAY = 'linear-gradient(rgba(5, 20, 40, 0.45), rgba(5, 20, 40, 0.55))'

/**
 * Full-size crossfading slideshow behind the Home page (navbar included).
 * Each slide also zooms in slowly while it is shown; reduced-motion users get plain fades.
 */
const HomeBackdrop = () => {
  const [active, setActive] = useState(0)
  const reduceMotion = useMediaQuery('(prefers-reduced-motion: reduce)')

  useEffect(() => {
    // load every slide up front so no fade shows a blank frame
    HOME_BACKGROUNDS.forEach((src) => { const img = new Image(); img.src = src })
  }, [])

  useEffect(() => {
    if (HOME_BACKGROUNDS.length < 2) return
    const t = setInterval(() => {
      if (document.hidden) return               // background tab: don't advance
      setActive((i) => (i + 1) % HOME_BACKGROUNDS.length)
    }, SLIDE_MS)
    return () => clearInterval(t)
  }, [])

  return (
    <Box aria-hidden="true" sx={{ position: 'absolute', inset: 0, zIndex: 0, overflow: 'hidden', backgroundColor: '#050d1c' }}>
      {HOME_BACKGROUNDS.map((src, i) => {
        const on = i === active
        return (
          <Box
            key={src}
            sx={{
              position: 'absolute',
              inset: 0,
              backgroundImage: `${OVERLAY}, url("${src}")`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat',
              opacity: on ? 1 : 0,
              transform: !reduceMotion && on ? 'scale(1.06)' : 'scale(1)',
              // fade quickly; zoom over the whole time the slide is shown
              transition: reduceMotion
                ? `opacity ${FADE_MS}ms ease`
                : `opacity ${FADE_MS}ms ease, transform ${on ? SLIDE_MS + FADE_MS : 0}ms linear ${on ? 0 : FADE_MS}ms`,
              willChange: 'opacity, transform',
            }}
          />
        )
      })}
    </Box>
  )
}

export default HomeBackdrop
